import { createReducer } from '../../utilities';

import { scope } from '../../../actions/app/mpt/weeks';
import {
    GET_MPT_WEEKS, GET_MPT_WEEKS_SUCCESS, GET_MPT_WEEKS_ERROR,
    EDIT_MPT_WEEK, EDIT_MPT_WEEK_SUCCESS, EDIT_MPT_WEEK_ERROR,
    EDIT_MPT_CARD, EDIT_MPT_CARD_SUCCESS, EDIT_MPT_CARD_ERROR,
    EDIT_MPT_DESTINATION, EDIT_MPT_DESTINATION_SUCCESS, EDIT_MPT_DESTINATION_ERROR,
    POST_MPT_DESTINATION, POST_MPT_DESTINATION_SUCCESS, POST_MPT_DESTINATION_ERROR,
    POST_MPT_DESTINATION_D0, POST_MPT_DESTINATION_D0_SUCCESS, POST_MPT_DESTINATION_D0_ERROR,
    POST_MPT_DESTINATION_D6, POST_MPT_DESTINATION_D6_SUCCESS, POST_MPT_DESTINATION_D6_ERROR,
    POST_MPT_WEEK, POST_MPT_WEEK_SUCCESS, POST_MPT_WEEK_ERROR, VALIDATE_TRANSFERT_ERROR,
    CHECK_RUNNING_SUCCESS,
} from '../../../actions/entities/mpt/weeks';

const initialWeeksState = {
    ids: [],
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false,
        jobRunning: 'loading',
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { ids, receivedAt, success } = action;
    return {
        ...state,
        ids,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    }
}

function successRunning(state, action) {
    const { jobRunning } = action;
    return {
        ...state,
        info: {
            ...state.info,
            jobRunning,
        }
    }
}


function fail(state, action) {
    const { error } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialWeeksState, {
    [GET_MPT_WEEKS]: request,
    [GET_MPT_WEEKS_SUCCESS]: success,
    [GET_MPT_WEEKS_ERROR]: fail,

    [EDIT_MPT_WEEK]: request,
    [EDIT_MPT_WEEK_SUCCESS]: success,
    [EDIT_MPT_WEEK_ERROR]: fail,

    [EDIT_MPT_CARD]: request,
    [EDIT_MPT_CARD_SUCCESS]: success,
    [EDIT_MPT_CARD_ERROR]: fail,

    [EDIT_MPT_DESTINATION]: request,
    [EDIT_MPT_DESTINATION_SUCCESS]: success,
    [EDIT_MPT_DESTINATION_ERROR]: fail,

    [POST_MPT_DESTINATION]: request,
    [POST_MPT_DESTINATION_SUCCESS]: success,
    [POST_MPT_DESTINATION_ERROR]: fail,

    [POST_MPT_DESTINATION_D0]: request,
    [POST_MPT_DESTINATION_D0_SUCCESS]: success,
    [POST_MPT_DESTINATION_D0_ERROR]: fail,

    [POST_MPT_DESTINATION_D6]: request,
    [POST_MPT_DESTINATION_D6_SUCCESS]: success,
    [POST_MPT_DESTINATION_D6_ERROR]: fail,

    [POST_MPT_WEEK]: request,
    [POST_MPT_WEEK_SUCCESS]: success,
    [POST_MPT_WEEK_ERROR]: fail,

    [VALIDATE_TRANSFERT_ERROR]: fail,

    [CHECK_RUNNING_SUCCESS]: successRunning,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/mpt/weeks.js